<template>
    <div>
        <v-dialog v-model="dialogVisible" width="700">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Create Group of Traits
                </v-card-title>

                <v-card-text>
                    <div class="std-padding-side">
                        <v-layout wrap>
                            <v-flex class="xs12">
                                <v-text-field
                                    v-model="SeriesName"
                                    v-validate="''"
                                    label="Series Name"

                                    type="text"
                                    :error-messages="errors.collect('SeriesName')"
                                    :data-vv-name="'SeriesName'"
                                    required
                                />
                            </v-flex>
                        </v-layout>

                        <div class="">
                            <trait-select-form :is-emit-to-parent="isEmitToParent" @emitTraitForms="emitTraitForms($event)" />
                        </div>
                    </div>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" class="v-btn-bold-color" @click="saveParams()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: ["tableId","dialog"],
    data () {
        return {
            SeriesName: "",

            // Dialog Show or not show
            dialogVisible: false,

            TraitInfo: "",
            isEmitToParent: false,
        };
    },
    watch: {
        dialogVisible() {
            this.$emit("update:dialog", this.dialogVisible);
            this.$emit("update:isEdit", this.dialogVisible);
            if (this.dialogVisible == false && this.selectId) this.$emit("update:selectId", "");
        },
        dialog() {
            this.dialogVisible = this.dialog;
            this.SeriesName = "";
        },
    },
    methods: {
        addTrait() {
            this.numberFilters.push({
                id: this.nextFilterId++,
                field_selected: "",
                parameter1: "",
                parameter2: ""
            });
        },
        updateTrait() {
            var self = this;
            axios({
                method: "PUT",
                url: "Series/Update",
                data: {
                    "id": self.selectId,
                    "name": self.SeriesName,
                },
            })
                .then(function (response) {
                    self.dialogVisible = false;
                    self.reloadTable("#" + self.tableId);
                });
        },
        emitTraitForms(event) {
            this.isEmitToParent = false;
            var self = this;
            axios({
                method: "POST",
                url: "Series/CreateSeriesWithTrait",
                data: {
					  	"name": self.SeriesName,
					  	"isPublic": true,
					  	"seriesTraits": event
                },
            })
                .then(function (response) {
                    self.dialogVisible = false;
                    self.reloadTable("#" + self.tableId);
                });
        },
        saveParams() {
            if (this.selectId) this.updateTrait();
            else this.isEmitToParent = true;
        },
        deleteTrait(index) {
            if (this.nextFilterId > 2) {
                this.numberFilters.splice(index, 1);
                this.nextFilterId--;
            }
        },
    }
};
</script>

<style scoped>
.formInlineText{
	margin: 0 1rem;
}
/*.plusBtn{
	color: #007bff;
}*/
</style>


// WEBPACK FOOTER //
// src/smallComponents/traitDialog.vue